import css from 'styled-jsx/css'

const staticStyles = css`
  .IssuesPanel {
    position: relative;
  }
`

export default staticStyles
